<div class="scss-drawer-container h-100 background-base-0" [attr.data-sb-qa]="qaTag">
    <div #layoutContainer class="v3 scss-drawer-layout" >
    <!-- This is the div that is animating -->
        <div class="h-100 d-flex flex-column"> 
            <div tabindex="0" id="drawerHeader" #drawerHeader class="d-flex flex-column position-sticky top-0 scss-drawer-header">
                @if (includeHeader) {
                    <div class="d-flex align-items-center p-3 w-100">
                        @if (isOpenedFromAnotherDrawer && !disableBackButton) {
                            <lib-icon-button
                                [icon]="Icon.Common.ArrowBack"
                                [size]="ButtonSize.Large"
                                [kind]="ButtonKind.Neutral"
                                qaTag="drawer-back-button"
                                (clicked)="Back()">
                            </lib-icon-button>
                        }
                        <div class="typography-headline-medium scss-drawer-title">
                            <ng-content select="[title]"></ng-content>
                        </div>
                

                        <div class="d-flex ms-auto">
                            <ng-content select="[rightMenu]"></ng-content>
                            @if (hasDeleteIcon) {
                                <lib-icon-button
                                    qaTag="drawer-delete-icon-button"
                                    [icon]="Icon.Common.DeleteOutline"
                                    [size]="ButtonSize.Large"
                                    [kind]="ButtonKind.DangerTertiary"
                                    (clicked)="DeleteClicked()">
                                </lib-icon-button>
                            }
                            @if (windowWidth > width && hasFullScreenMode) {
                                <lib-icon-button
                                    [icon]="drawerState !== DrawerState.Fullscreen ? Icon.Common.Fullscreen : Icon.Common.FullScreenExit"
                                    [size]="ButtonSize.Large"
                                    [kind]="ButtonKind.Neutral"
                                    qaTag="drawer-toggle-fullscreen-icon-button"
                                    (clicked)="ToggleFullscreen()">
                                </lib-icon-button>
                            }
                            <lib-icon-button
                                [icon]="Icon.Common.Close"
                                [size]="ButtonSize.Large"
                                [kind]="ButtonKind.Neutral"
                                qaTag="drawer-close-icon-button"
                                (clicked)="Close()">
                            </lib-icon-button>
                        </div>
                    </div>
                }
            </div>

            <div #transientHeader>
                <ng-content select="[addToHeader]"></ng-content>
            </div>

            <div #additionalStickyHeader id="additional-drawer-header" class="position-sticky" [ngClass]="{'border-bottom': includeHeader}">
                <ng-content select="[addToStickyHeader]"></ng-content>
            </div>

            <div #drawerContent>
                <ng-content select="[content]"></ng-content>
            </div>

            
        @if (includeFooter) {
            <div  #drawerFooter class="mt-auto scss-drawer-footer" [ngClass]="{'position-sticky bottom-0': isDesktop, 'padding-bottom-8': isStandalone}">
                <ng-content select="[submissionBar]"></ng-content>
            </div>
        }
        
        </div>
    </div>
</div>